import './TournamentSchedule.css'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useGetStageQuery } from '../../redux/stageService/stageApiSlice'
import { assignAlphabeticalNames } from '../../generalExternalFunctions'
import { TableMatches } from '../TableMatches/TableMatches.js'
import { Match } from '../Match/Match'

const TournamentScheduleComponent = ({ menuTab, stageNumber, auth, match }) => {
	const { tournamentUid } = useParams()
	const matchIsActive = sessionStorage.getItem('activatedComponent')
	const tournamentState = useSelector(state => state.tournament.tournament)

	const { data: stageData = {}, error, isLoading, refetch } = useGetStageQuery({
		tournament_uid: tournamentUid,
		stageNumber: stageNumber
	}) // Stage data

	useEffect(() => {
		refetch()
	}, [refetch, stageNumber, tournamentState, menuTab])

	const [stage, setStage] = useState({})
	const [matchIsOpened, setMathIsOpened] = useState(matchIsActive ? true : false)
	const [matchData, setMatchData] = useState({})

	useEffect(() => {
		processData(stageData)
	}, [stageData, stageNumber, tournamentState, auth])

	const processData = (stage) => {
		if (Object.keys(stage).length !== 0) {
			const stageWithNamedGroups = assignAlphabeticalNames(stage)

			setStage(stageWithNamedGroups)
		}
	}

	const sendMatchData = useCallback((matchData) => {
		setMatchData(matchData)
		setMathIsOpened(true)
		match(true)
	}, [match])

	const closeMatch = useCallback(() => {
		setMathIsOpened(false)
		match(false)
	}, [match])

	if (error) { console.log(error) }
	if (isLoading) { return <h1>Loading</h1> }

	return (
		<div className="schedule__container">
			{
				!matchIsOpened ?
					<TableMatches
						data={stage}
						tournamentState={tournamentState}
						sendMatchData={sendMatchData}
						auth={auth}
					/>
					:
					<Match match={matchData} closeMatch={closeMatch} />
			}
		</div>
	)
}

export const TournamentSchedule = memo(TournamentScheduleComponent)